import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { SYS4090_R01Dto } from "./Dto_SYS4090_R01";
import { getData, postData, putData, deleteData, patchData } from "src/utils/axios/serverHelper";
import { SYS4090_R01Filter } from "./Store_SYS4090_R01";

const baseUrl = `${config.apiUrl}/SYS4090_R01`;

// 은행계좌 목록 조회 (GET)
export const getSYS4090_R01List = async (option: string, params: Partial<SYS4090_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<SYS4090_R01Dto[]>>(url, { params: {
		...params,
		listLength
	} });
};

export const getSYS4090_R01AllCount = async (params: Partial<SYS4090_R01Filter>) => {
	const url = `${baseUrl}/allCount`;

	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

export const getSYS4090_R01One = async (bankAcctCd: string) => {
	const url = `${baseUrl}/one/${bankAcctCd}`;

	return await getData<ResponseDto<SYS4090_R01Dto>>(url);
}

// 은행계좌 등록 (POST)
export const createSYS4090_R01 = async (data: SYS4090_R01Dto) => {
    // console.log('은행계좌 등록 API 호출 URL:', baseUrl);
    // console.log('등록 데이터:', data);
    return await postData<SYS4090_R01Dto, ResponseDto<SYS4090_R01Dto[]>>(baseUrl, data);
};

// 은행계좌 수정 (PATCH)
export const patchSYS4090_R01 = async (data: SYS4090_R01Dto) => {
    // console.log('은행계좌 수정 API 호출 URL:', baseUrl);
    // console.log('수정 데이터:', data);
    return await patchData<SYS4090_R01Dto, ResponseDto<SYS4090_R01Dto[]>>(baseUrl, data);
};

// 은행계좌 삭제 (DELETE)
export const deleteSYS4090_R01 = async (bankAcctCd: string) => {
    // console.log('은행계좌 삭제 API 호출 URL:', `${baseUrl}/${bankAcctCd}`);
    return await deleteData<ResponseDto<any>>(`${baseUrl}/${bankAcctCd}`);
};

// 엑셀 다운로드
export const downloadExcel_SYS4090_R01 = async (option: string, params: Partial<SYS4090_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;
    return await getData<ResponseDto<string>>(url, { params: {
		...params,
		listLength
	} });
};









